import { render, staticRenderFns } from "./dict.vue?vue&type=template&id=2fb2fe9c&"
import script from "./dict.vue?vue&type=script&lang=js&"
export * from "./dict.vue?vue&type=script&lang=js&"
import style0 from "./dict.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports